import { QueryResultColumn } from "../../../utils/Types";

export const getDefaultAxis = ({
  options,
  defaultName,
  isY,
  defaultXAxisNameForPreventingDuplicate,
}: {
  options?: QueryResultColumn[];
  defaultName?: string;
  isY: boolean;
  defaultXAxisNameForPreventingDuplicate?: string;
}) => {
  let defaultAxis = undefined;
  if (options && options.length > 0) {
    if (defaultName) {
      defaultAxis = options.find((i) => i.name === defaultName);
    } else {
      if (isY) {
        if (defaultXAxisNameForPreventingDuplicate) {
          const optionsY = options.filter(
            (y) => y.name !== defaultXAxisNameForPreventingDuplicate,
          );
          if (optionsY.length > 0) {
            defaultAxis = optionsY[0];
          }
        } else {
          defaultAxis = options[0];
        }
      } else {
        defaultAxis = options[0];
      }
    }
  }
  return defaultAxis;
};
